import { useEffect } from 'react';

/** Seletores onde o clique não deve limpar a seleção (OS / ações da seleção / overlays). */
const BOARD_SELECTION_KEEP_SELECTORS = [
  '.order-row',
  '.technician-order-row',
  '.context-menu',
  '.board-order-context-menu',
  '.city-dropdown',
  '.city-header',
  // Detalhe OS / modais: clique no backdrop deve fechar o modal, não “roubar” o evento limpando a seleção
  '.modal-overlay',
  '.order-details-modal-overlay',
  '.order-details-mock-overlay',
  '[role="dialog"][aria-modal="true"]',
];

/**
 * True quando há ao menos 1 OS selecionada (clique fora deve limpar).
 * @param {unknown} selectedOrders
 */
export function hasBoardOrderSelectionToClear(selectedOrders) {
  return Array.isArray(selectedOrders) && selectedOrders.length >= 1;
}

/**
 * True se o alvo do clique está em área que mantém a seleção (linha de OS, menu, cidade).
 * @param {EventTarget | null} target
 */
export function isBoardOrderSelectionKeepTarget(target) {
  if (!(target instanceof Element)) return false;
  return BOARD_SELECTION_KEEP_SELECTORS.some((sel) => target.closest(sel));
}

/**
 * Com 1+ OS selecionadas no Board, clique fora das linhas de OS limpa a seleção.
 * Ignora menu de contexto, dropdown de cidade e overlays/modais (ex.: detalhe OS).
 * Clique na própria linha (ex.: início de drag) não limpa.
 */
export function useClearMultiOrderSelectionOnOutsideClick(selectedOrders, setSelectedOrders) {
  useEffect(() => {
    if (!hasBoardOrderSelectionToClear(selectedOrders)) return undefined;

    const handlePointerDown = (event) => {
      if (isBoardOrderSelectionKeepTarget(event.target)) return;
      setSelectedOrders([]);
    };

    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [selectedOrders, setSelectedOrders]);
}
